import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import {
  AutoRefreshTokenService,
  CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  CustomBearerTokenCondition,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken,
} from 'keycloak-angular';
import { ADD_BEARER_TOKEN } from './bearer-token-context';
import { AuthenticationService } from '../services/authentication.service';

export interface KeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
}

/** Attaches the bearer only to requests that opt in via `withBearerToken()`. */
export const SOL_BEARER_TOKEN_CONDITIONS: CustomBearerTokenCondition[] = [
  { shouldAddToken: async (request: HttpRequest<unknown>) => request.context.get(ADD_BEARER_TOKEN) },
];

export function provideSolAuthentication(config: KeycloakConfig): (EnvironmentProviders | Provider)[] {
  return [
    provideKeycloak({
      config: {
        url: config.url,
        realm: config.realm,
        clientId: config.clientId,
      },
      initOptions: {
        checkLoginIframe: false,
        onLoad: 'login-required',
      },
      features: [
        withAutoRefreshToken({
          onInactivityTimeout: 'none',
        }),
      ],
      providers: [AutoRefreshTokenService, UserActivityService],
    }),
    {
      provide: CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: SOL_BEARER_TOKEN_CONDITIONS,
    },
    provideAppInitializer(() => {
      const authenticationService = inject(AuthenticationService);
      authenticationService.initialize();
    }),
  ];
}
